import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface rUi {
	sidebar: {
		collapsed: boolean;
	};
	dimensions: {
		isTabletOrMobile: boolean;
	};
}

const initState: rUi = {
	sidebar: {
		collapsed: false,
	},
	dimensions: {
		isTabletOrMobile: false,
	},
};

// actions
const reset = (): rUi => initState;
const setDimensionTabletOrMobile: CaseReducer<rUi, PayloadAction<boolean>> = (
	state,
	action
): rUi => ({
	...state,
	dimensions: {
		...state.dimensions,
		isTabletOrMobile: action.payload,
	},
});
const toggleSidebarCollapse: CaseReducer<rUi> = (state): rUi => ({
	...state,
	sidebar: {
		...state.sidebar,
		collapsed: !!!state.sidebar.collapsed,
	},
});

// slice
const uiSlice = createSlice({
	name: "ui",
	initialState: initState,
	reducers: { reset, setDimensionTabletOrMobile, toggleSidebarCollapse },
});

// exports
export const uiActions = uiSlice.actions;
export default uiSlice;
